/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Route } from 'react-router';
import type { AppRoute } from './app.routes';
import {
  ELSCommonConfig,
  ELSCommonUIConstants,
  ELSStorageHelper
} from '@els/els-ui-common-react';
import { Redirect } from 'react-router-dom';
import { ReactNode } from 'react';

const createPrivateRoute = ({ component: Component, ...route }: AppRoute) : React.ReactElement => (
  <Route
    key={route.path}
    {...route}
    render={props =>
      (ELSStorageHelper.driver(ELSCommonConfig.storageDriver)
        .namespace(ELSCommonUIConstants.security.Locker.TokenNamespace)
        .get(ELSCommonUIConstants.security.Locker.TokenCacheKey) ? (
          <Component {...(props as any)} {...{ aaData: route.data }} />
        ) : (
          <Redirect
          to={{
            pathname: `/${ELSCommonUIConstants.security.States.NotAuthorized}`,
            state: { from: props.location }
          }}
        />
        ))}
  />
);

export const createRoute = (route: AppRoute): ReactNode => {
  const RouteComponent = route.component;
  const injectedRoute = { ...route, component: RouteComponent };
  if (injectedRoute.isPrivate) {
    return createPrivateRoute(injectedRoute);
  }
      return (
    <Route
      key={injectedRoute.path}
      path={injectedRoute.path}
      exact={injectedRoute.exact}
      render={props => <RouteComponent {...(props as any)} {...{ aaData: route.data }} />}
    />
  );
};
